<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Upload Plan</strong></b-breadcrumb>

    <div class="design-container-details__main p-5">
        <div class="col-md-12 ">
            <b-form
            @submit.prevent="validateForm('form-1')"
            data-vv-scope="form-5"
            >
            
            <div class="row">
                <div class="col-md-5">
                    <b-form-group  label="Select Season" :label-cols="3">
                        <b-form-select v-model="season_type" id="season_type" name="season_type" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.season_type') }" required>
                        <option value="">Select Season</option>
                            <option
                                v-for="collection in collection_type"
                                :value="collection.title"
                            >
                                {{ collection.title }}
                            </option>
                        </b-form-select> 
                
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                            <i class="fa fa-warning" v-show="errors.has('season_type')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.season_type')" id="statustxt" class="help text-danger">{{ errors.first('form-1.season_type') }}
                        </code>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="col-md-5"> 
                    <b-form-group
                        label="Upload Plan"
                        :label-cols="3"               
                        >
                        <b-form-file
                            v-model="file"
                            :state="Boolean(file1)"
                            placeholder="Upload Plan"
                           accept=".xlsx"
                            @change="selectFile($event)"
                             required
                            :class="{
                                input: true,
                                'text-danger': errors.has('form-1.file'),
                            }"
                        ></b-form-file>

                        <b-input-group>
                            <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('file')"></i>
                            </span>
                            <span
                                style="width:240px"
                                v-show="errors.has('form-1.file')"
                                class="help text-danger"
                                >{{ errors.first("form-1.file") }}</span
                            >
                            </b-input-group>

                            <!-- Code For Progress Bar -->
                            <div
                            class="progress"
                            id="progress_bar"
                            style="display:none; margin-top: 7px; margin-bottom: 7px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;"
                            >
                            <div
                                class="progress-bar progress-bar-info progress-bar-striped"
                                role="progressbar"
                                :aria-valuenow="progress"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                :style="{
                                height: '30px',
                                text: '20px',
                                align: 'center',
                                width: progress + '%',
                                }"
                            >
                                {{ progress }}%
                            </div>
                            </div>
                            <!-- Code For Progress Bar Ends -->
                        
                    </b-form-group>
                </div>
                <!-- <button @click="downoadplanupload()">download</button> -->

                <div class="col-md-2"> 
                    <b-button
                        type="submit"
                        size="md"
                        class="mr-4 pull-right text-right"
                        variant="primary"
                        style="float: right"
                        >Save</b-button
                    >
                </div>
            </div>

            </b-form>
            
        </div>

    </div>
  </div>



</template>

<script>
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Utils from "@/utils";
import { ToggleButton } from "vue-js-toggle-button";
import Datepicker from "vuejs-datepicker";
Vue.component("ToggleButton", ToggleButton);
// import auth from "@/utils/auth";

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";
import Table from "../views/base/Table.vue";

const axios = require("axios");
export default {
  name: "upload_plan",
  components: {
    sidebarSettingsComponent,
    Table,
 
  },
  data() {
     return {
        collection_type:[],
        totalRows: 0,
        season_type:'',
        selectedFiles:'',
        imgname:'',
        file: "",
        progress:0,
        sampleImageurl:'',

    };
  },

    created: function() {
        var userData = localStorage.getItem("userData");
        if (userData) {
         this.getcollectionlisting();
        }

  },


  methods:{

       /****** Function to  Get Collection List ********/
    getcollectionlisting: function(value) {
      axios
        .post(`${CONSTANTS.API_URL}/getDefaultCollectionTitle`, {})
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg === "Successful") {
            this.collection_type = response.data.returnvalue;
            this.totalRows = response.data.returnvalue.length;
            //this.isBusy = !this.isBusy;
          } else {
            this.collection_type = [];
            this.totalRows = 0;
          }
        })
    },


    /****** Function to uoload plan file Start ********/

    selectFile(event) {
      this.selectedFiles = event.target.files[0];
      this.imgname = this.selectedFiles.name;

    },


    sampleImage: function () {
      if (this.selectedFiles != undefined) {
        document.getElementById("progress_bar").style.display = "block";
        document.getElementById("overlay").style.display = "block";
        this.progress = 0;
        let data = new FormData();
        let config = {
          header: {
            "Content-Type": "multipart/form-data",
          },
        };
        data.append("file", this.selectedFiles);
        axios
          .post(`${CONSTANTS.API_URL}/uploadfiletos3`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
          onUploadProgress: function(progressEvent) {
                this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
                );
            }.bind(this),
            })
          .then((response) => {
           
           document.getElementById("overlay").style.display = "none";
            // document.getElementById("overlay").style.display = "none";
            if (response.data.result == "success") {
               this.progress = Math.round((100 ));
              this.sampleImageurl = response.data.image_url;
              console.log("SFSFSFS", this.sampleImageurl);

            this.$fire({
                text: "File Uploaded Successfully.",
                type: "success",
                timer: 30000,
              });

            } else {
               this.$fire({
                text: "Error in file uploading, Please try again",
                type: "error",
                timer: 30000,
              });
              this.sampleImageurl = "";
            }
          });
      }
    },
    /****** Function to uoload plan file end ********/


    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.csvFilesUpload(scope);
        }
      });
    },

    csvFilesUpload(){
        document.getElementById("overlay").style.display = "block";
        var userData = localStorage.getItem("userData");
        var userInfo = JSON.parse(userData);

        let data = new FormData();

        data.append("file", this.selectedFiles);
        data.append("file", this.imgname);
        data.append("user_id", userInfo[0].user_id);
        data.append("createdby", userInfo[0].user_id);
        data.append("season_name", this.season_type);

    
        // const obj ={
        //     user_id : userInfo[0].user_id,
        //     created_by : userInfo[0].user_id,
        //     season_name: this.season_type,
        //     uploaded_file: this.sampleImageurl
        // }
        axios
            .post(`${CONSTANTS.API_URL}/uploadPlanCsv`, data )
            .then((response) => {
            document.getElementById("progress_bar").style.display = "none";
            document.getElementById("overlay").style.display = "none";
            if (response.data.returnmsg == "Successful") {
                this.$fire({
                text: response.data.returnvalue,
                type: "success",
                timer: 30000,
              });
            this.season_type = ''
            this.sampleImageurl =''
            this.selectedFiles  = ''
            this.file = ''
                  
            }else{  

                let returnValue = response.data.returnvalue
                // Split the message based on the semicolon
                let messages = returnValue.split(";");

                // Extract the unique message
                let uniqueMessage = messages[0].trim();

                // Display the message
                console.log(uniqueMessage);
                this.$fire({
                text: uniqueMessage,
                type: "error",
                timer: 30000,
              });
             this.season_type = ''
            this.sampleImageurl =''
            this.selectedFiles = ''
            this.file = ''
            }
          
            });

    },




}
};
</script>

